<span class="slider-wrapper" mat-button (click)="showCartClick()">
    <div class="fa-1x">
        <span class="fa-layers icon-wrapper" style="">
            <i class="fas fa-shopping-cart"></i>
            <span *ngIf="totals$ | async as totals" class="icon-total fa-layers-counter fa-layers-bottom-left">{{ totals.total | currency:'EUR' }}</span>
        </span>
    </div>
</span>
<span class="cdk-visually-hidden">Access to see the shopping cart</span>
